/** @format */
import React, { FunctionComponent } from 'react';
import { SimCardServiceTypeAllowedParam, SimCardServiceTypeAllowedParamMapBme } from '../../../../interfaces/collections/SimCardServiceInterface';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import I18n from '../../../../components/Translate/I18n';
import { getFeatureVerbName } from '../../../../modules/features/FeaturesTypes';
import { Typography } from '@material-ui/core';
import { BoolTranslateHelper } from '../../../../helpers/BoolTranslateHelper';

const _ = require('underscore');

type OplSimCardServiceTypeBmeParamType = {
    param: SimCardServiceTypeAllowedParam;
    id: number;
};

export const OplSimCardServiceTypeBmeParam: FunctionComponent<OplSimCardServiceTypeBmeParamType> = ({ param, id }): React.ReactElement => {
    const parameters = JSON.parse(param.parameters);

    const processParams = (params: SimCardServiceTypeAllowedParamMapBme, paramName: string): React.ReactElement => {
        return (
            <GridItem xs={12} key={'root_main_params_loop_' + paramName + id}>
                <I18n trans="prov:feature.param_name" valueObject={{ param_name: paramName }} />
                <GridContainer>
                    <GridItem xs={6}>
                        <I18n trans="prov:feature.required" />
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={BoolTranslateHelper(params.required)} />
                    </GridItem>
                    {params.parameterType === 'NUMBER' && (
                        <React.Fragment>
                            <GridItem xs={6}>
                                <I18n trans="prov:feature.type" />
                            </GridItem>
                            <GridItem xs={6}>integer</GridItem>
                        </React.Fragment>
                    )}
                    {params.allowedValue && params.allowedType === 'arrayString' && (
                        <React.Fragment key={'key_app' + paramName}>
                            <GridItem xs={6}>
                                <I18n trans="prov:feature.allowed_value" />
                            </GridItem>
                            <GridItem xs={6}>
                                {params.allowedValue.map((aValue) => (
                                    <React.Fragment key={'app' + aValue ?? paramName}>{aValue},</React.Fragment>
                                ))}
                            </GridItem>
                        </React.Fragment>
                    )}
                </GridContainer>
            </GridItem>
        );
    };

    const result: Array<React.ReactElement> = [];
    if (parameters) {
        _.mapObject(parameters, (val: any, key: string): any => {
            _.mapObject(val.parameters, (val1: any, key1: string): any => {
                if (val1.guiView) {
                    result.push(processParams(val1, key1));
                }
            });
        });
    }

    return (
        <GridContainer>
            <GridItem xs={12}>
                <hr />
                <GridContainer>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2">
                            <I18n trans="prov:feature.operation_name" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2">
                            <I18n trans={'prov:feature.' + getFeatureVerbName(param.operationVerbId)} />
                        </Typography>
                    </GridItem>
                    {result.map((item) => item)}
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
